var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralIconsClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.499,
    height: 27.499,
    viewBox: "0 0 27.499 27.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-10.833-16.5l8.814-8.814L-.2-27.131a.688.688,0,0,0,0-.972l-1.945-1.945a.688.688,0,0,0-.972,0L-13.75-19.417-24.381-30.049a.688.688,0,0,0-.972,0L-27.3-28.1a.688.688,0,0,0,0,.972L-16.667-16.5-27.3-5.869a.688.688,0,0,0,0,.972l1.945,1.945a.688.688,0,0,0,.972,0L-13.75-13.583-4.936-4.77l1.818,1.818a.688.688,0,0,0,.972,0L-.2-4.9a.688.688,0,0,0,0-.972Z",
    transform: "translate(27.5 30.25)",
    fill: "#191919",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIconsClose);
export default __webpack_public_path__ + "static/media/generalIcons_Close.644e377de552108c896072be519dfd49.svg";
export { ForwardRef as ReactComponent };